/* eslint-disable  import/prefer-default-export */
const DATA_TESTID_SUFFIXES = {
  SELECT_PANE: 'selectpane',
  SELECT_ITEM: 'selectitem',
  SELECT_BUTTON: 'selectbutton',
  SELECT_SEARCH: 'selectsearch',
  SELECT_BACK: 'selectback'
};
const KEYS = {
  CHECK_PARENT: [' ']
};

export { DATA_TESTID_SUFFIXES, KEYS };
